"use strict";

define('model/board.member',['./base', '../collection/base', './group.member', './attribute.value', './attribute', './person', 'datakit/util/url'], function (BaseModel, BaseCollection, GroupMember, AttributeValueModel, AttributeModel, PersonModel, _url) {
  var boardIdGeneratorAdapter = {
    postprocess: function postprocess(data) {
      _.each(data, function (bm) {
        if (bm && bm.person) {
          bm.id = bm.person.id;
        }
      });
    }
  };
  var BoardMember = GroupMember.extend({
    defaults: function defaults() {
      return {
        attributeValues: []
      };
    },
    url: function url() {
      this._ensureGroup();
      return _url.template('/rs/api/boardMember/:personId/:groupId', {
        personId: this.get('person').id,
        groupId: this.get('group').id
      });
    },
    childModels: {
      person: 'Person',
      attributeValues: 'AttributeValue',
      group: 'Board'
    },
    virtual: {
      personDisplayName: GroupMember.createKeyPathVirtual('person.displayName'),
      degrees: function degrees() {
        return this.findAttributeValueByName('Degrees').get('value');
      },
      membership: function membership() {
        return this.findAttributeValueByName('Membership Status').get('value');
      },
      representation: function representation() {
        return this.findAttributeValueByName('Representation').get('value');
      },
      affiliation: function affiliation() {
        return this.findAttributeValueByName('Affiliation').get('value');
      },
      office: function office() {
        return this.findAttributeValueByName('Office').get('value');
      },
      scientificStatus: function scientificStatus() {
        return this.findAttributeValueByName('Scientific Status').get('value');
      },
      startDate: function startDate() {
        return this.findAttributeValueByName('Tenure').get('startDate');
      },
      endDate: function endDate() {
        return this.findAttributeValueByName('Tenure').get('endDate');
      },
      alternates: function alternates() {
        return this.filterAttributeValuesByName('Alternate').map(function (av) {
          var person = new PersonModel(av.get('value'));
          return person.get('displayName');
        }).join(', ');
      },
      alternatesFor: function alternatesFor() {
        return this.filterAttributeValuesByName('Alternate For').map(function (av) {
          var person = new PersonModel(av.get('value'));
          return person.get('displayName');
        }).join(', ');
      }
    },
    alternatesForCollection: function alternatesForCollection() {
      var data = this.filterAttributeValuesByName('Alternate For').map(function (av) {
        return new PersonModel(av.get('value'));
      });
      return new BaseCollection(data);
    },
    findAttributeValueByName: function findAttributeValueByName(name, options) {
      options = options || {};
      this._ensureAttributeValues();
      var model = this.get('attributeValues').find(function (model) {
        return model.get('attribute').get('name') == name;
      });
      if (!this.get('person')) {
        this.set('person', new PersonModel());
      }
      if (!model && !options.allowNull) {
        model = this.addAttributeValue(null, name);
      }
      return model;
    },
    filterAttributeValuesByName: function filterAttributeValuesByName(name) {
      this._ensureAttributeValues();
      var models = this.get('attributeValues').filter(function (model) {
        return model.get('attribute').get('name') == name;
      });
      return new BaseCollection(models, {
        model: AttributeValueModel
      });
    },
    addAttributeValue: function addAttributeValue(value, name) {
      this._ensureGroup();
      this._ensureAttributeValues();
      var model = new AttributeValueModel({
        value: value,
        group: this.get('group'),
        person: this.get('person'),
        attribute: new AttributeModel({
          name: name
        })
      });
      this.get('attributeValues').add(model);
      return model;
    },
    _ensureAttributeValues: function _ensureAttributeValues() {
      var attributeValues = this.get('attributeValues');
      if (!attributeValues) {
        this.set('attributeValues', []);
      }
      return this;
    },
    _ensureGroup: function _ensureGroup() {
      var group = this.get('group');
      if (!group) {
        this.set('group', {});
        group = this.get('group');
      }
      if (group.id == null) {
        if (this.collection && this.collection._params) {
          this.set('group', {
            id: Number(this.collection._params.get('id'))
          });
        }
      }
      return this;
    },
    isNew: function isNew() {
      if (this._isNotNew) {
        this._isNotNew = false;
        return false;
      }
      return GroupMember.prototype.isNew.apply(this, arguments);
    },
    destroy: function destroy(options) {
      var self = this;
      options = _.extend({}, options, {
        success: function success() {
          self._isNotNew = true;
        }
      });
      this._isNotNew = true;
      return GroupMember.prototype.destroy.call(this, options);
    },
    toJSON: function toJSON() {
      var data = GroupMember.prototype.toJSON.apply(this, arguments);
      delete data.id;
      return data;
    }
  }, {
    membersCollection: function membersCollection(id, options) {
      options = options || {};
      return this.createCollection(options.noAttributes ? '/rs/api/boardMember/:id' : '/rs/api/boardMember/attributes/:id').addAdapter(boardIdGeneratorAdapter).params({
        id: id
      });
    },
    members: function members(id) {
      return this.createCollection('/rs/api/boardMember/:id').params({
        id: id
      });
    },
    membersByDateCollection: function membersByDateCollection(id, date) {
      return this.createCollection('/rs/api/boardMember/attributes/:id/:date').addAdapter(boardIdGeneratorAdapter).params({
        id: id,
        date: date
      });
    }
  });
  return BoardMember;
});

